import styled from "styled-components";
import { spacing } from "@styling/sizing";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;
`;

export const CheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x1}px;
  max-height: 220px;
  overflow: auto;
  padding: ${spacing.x1}px;
  border: 1px solid ${colors.border};
  border-radius: 4px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${spacing.x1}px;
  font-size: ${fontSizes.small}px;
  cursor: pointer;
`;

export const HoursGrid = styled.div`
  display: grid;
  grid-template-columns: 110px 80px 1fr 1fr;
  gap: ${spacing.x1}px;
  align-items: center;
`;

export const HoursDay = styled.span`
  font-size: ${fontSizes.small}px;
`;

export const SlotCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;
  padding: ${spacing.x2}px;
  border: 1px solid ${colors.border};
  border-radius: 4px;
`;

export const PriceRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 140px 140px;
  gap: ${spacing.x2}px;
  align-items: end;
`;

export const PriceTitle = styled.div`
  font-size: ${fontSizes.small}px;
  padding-bottom: ${spacing.x2}px;
`;
